/**
 * InstrumentRegistry.js
 * Unified source of truth for all instruments (Software & Hardware).
 * Merges INSTRUMENT_LIBRARY and HARDWARE_LIBRARY.
 */

import { INSTRUMENT_LIBRARY, BBCO_KEYSWITCHES, INSTRUMENT_HIERARCHY } from './InstrumentLibrary.js';
import { HARDWARE_LIBRARY } from './HardwareLibrary.js';

// Re-export constants and library for centralized access
export { BBCO_KEYSWITCHES, INSTRUMENT_HIERARCHY, INSTRUMENT_LIBRARY };

export const getAllInstruments = () => {
    return [...INSTRUMENT_LIBRARY, ...HARDWARE_LIBRARY];
};

export const getInstrument = (id) => {
    const sw = INSTRUMENT_LIBRARY.find(i => i.id === id);
    if (sw) return sw;
    return HARDWARE_LIBRARY.find(i => i.id === id);
};

export const getSoftwareInstruments = () => INSTRUMENT_LIBRARY;
export const getHardwareInstruments = () => HARDWARE_LIBRARY;
